
import Vue from 'vue';
import Component from 'vue-class-component';
import ConfirmationModel from '../ConfirmationModel';
import { Prop } from 'vue-property-decorator';

@Component
export default class ConfirmFinalize extends Vue {
    @Prop({
        type: ConfirmationModel,
        required: true,
    })
    public confirmationModel!: ConfirmationModel;
    public message: string = '';
    public dialogOpen: boolean = false;

    get isFinalizationMessage() {
        return this.message.includes('finalizację sesji');
    }

    public mounted() {
        this.confirmationModel.on('confirm', (message: string) => {
            this.dialogOpen = true;
            this.message = message;
        });
    }
}

export { ConfirmationModel };
